module.exports = __webpack_public_path__ + "static/media/IMG_1817.2bf9534d.JPG";